/* unplugin-vue-components disabled */import { render } from "./templateTextArea.vue?vue&type=template&id=3eb47dcc&scoped=true"
import script from "./templateTextArea.vue?vue&type=script&lang=js"
export * from "./templateTextArea.vue?vue&type=script&lang=js"

import "./templateTextArea.vue?vue&type=style&index=0&id=3eb47dcc&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb47dcc"]])

export default __exports__